import RegisterForm from './RegisterForm';

export default RegisterForm;


// WEBPACK FOOTER //
// ./src/components/forms/RegisterForm/index.js